import styled, { keyframes } from 'styled-components';

import LoginRoller from '../../../assets/login-roller.png';
import HealtheraConnectLogo from '../../../assets/healthera-connect-logo.png';

function SideBarComponent() {
  return (
    <SideBar>
      <AnimatedDiv />
      <img alt="Healthera Logo" src={HealtheraConnectLogo} />
      <SideBarHeader>
        With Healthera, <br /> Manage your pharmacies easily.
      </SideBarHeader>
    </SideBar>
  );
}

export default SideBarComponent;

const slide = keyframes`
100% {background-position:400000px}
`;

const SideBarHeader = styled.h1`
  && {
    margin-top: 3rem;
    font-family: Assistant;
    font-weight: bold;
    color: #ffffff;
    font-size: 2.5rem;
    line-height: 1.25;
  }
`;

const AnimatedDiv = styled.div`
  && {
    position: absolute;
    left: 0;
    bottom: 60px;
    animation: ${slide} 3200s infinite;
    width: 100%;
    height: 40vh;
    background: url(${LoginRoller});
    background-size: auto 40vh;
  }
`;

const SideBar = styled.div`
  && {
    min-width: 400px;
    width: 30%;
    max-width: 517px;
    background: #2f9d6d;
    overflow: hidden;
    position: relative;
    padding: 2rem;
    @media (max-width: 1000px) {
      display: none;
    }
  }

  && > img {
    width: 40%;
  }
`;
